export const PUBLIC_ROUTES: string[] = [
	'/extension/welcome',
	'/extension/log-out',
	'/extension/ntp-logout-redirect',
];
